// The offline code's wire vocabulary (spec/05 §8.4; F-SES-24).
//
// Staff read out an 8-digit code to start, extend or unlock a station while its venue is offline. The
// **derivation** — an HMAC-SHA256 of `(stationId, action, minutesBucket, timeStep)` truncated like
// TOTP — is `@clavian/domain`'s (`offline/code.ts`), byte-identical to the C# station. These are the
// plain vocabulary the api route and the station's reconnect report validate against.
//
// **Plain values only** — no Zod, no `createRoute` — so the eval-free `@clavian/contracts/constants`
// barrel can re-export them without dragging `@hono/zod-openapi`'s `new Function` into a browser bundle
// (the `session-pin.ts` precedent, `constants/index.ts`). The Zod schemas the routes and the realtime
// payload validate with are built from these in `realtime/station.ts`, where the OpenAPI Zod lives. A
// server drift-guard test asserts these stay identical to the domain's own constants.
/** What an offline code authorises (spec/05 §8.4). Kept in step with `@clavian/domain`'s `OFFLINE_CODE_ACTIONS`. */
export const OFFLINE_CODE_ACTIONS = ['start', 'extend', 'maintenance'];
/** The minute amounts a code can carry; a code is bound to exactly one (spec/05 §8.4). */
export const OFFLINE_CODE_MINUTE_BUCKETS = [15, 30, 60, 90, 120, 180, 240];
/** How many digits a code has. */
export const OFFLINE_CODE_DIGITS = 8;
/** The 10-minute window a code is minted in and accepted for (with the previous one), in seconds. */
export const OFFLINE_CODE_TIME_STEP_SECONDS = 600;
/** An 8-digit code, digits only — the one source of the shape for the api, the station and the console. */
export const OFFLINE_CODE_PATTERN = new RegExp(`^\\d{${OFFLINE_CODE_DIGITS}}$`);
/** Is `value` a well-formed offline code — 8 digits, nothing else? */
export function isOfflineCodeShape(value) {
    return OFFLINE_CODE_PATTERN.test(value);
}
//# sourceMappingURL=offline-code.js.map